function parsedHasExpectedKey(key, parsed) {
  if (typeof parsed !== 'object' || parsed === null || !(key in parsed)) {
    return false;
  }
  return true;
}
export async function* streamResponsePreview({
  streamingResponseGenerator,
  isConvoAI,
  streamingListener
}) {
  let partialMeta = {
    inputOutputDiffRatio: ''
  };
  let partial = {
    type: 'markdown',
    content: '',
    meta: partialMeta
  };
  for await (const yieldedResponse of streamingResponseGenerator) {
    if (yieldedResponse.state === 'loaded-stream') {
      return yield {
        state: 'loaded',
        data: partial
      };
    }
    if (yieldedResponse.state === 'created-channel') {
      return yield {
        state: 'created-channel',
        data: yieldedResponse.data
      };
    }
    if (yieldedResponse.state === 'loading' || yieldedResponse.state === 'loaded') {
      if (parsedHasExpectedKey('generatedContent', yieldedResponse.data)) {
        partial = {
          type: 'markdown',
          content: partial.content + yieldedResponse.data['generatedContent'],
          meta: parsedHasExpectedKey('meta', yieldedResponse.data) && parsedHasExpectedKey('inputOutputDiffRatio', yieldedResponse.data.meta) ? {
            inputOutputDiffRatio: yieldedResponse.data['meta']['inputOutputDiffRatio'],
            loadingStatus: ''
          } : partial.meta
        };
        if (streamingListener) {
          streamingListener(partial.content, yieldedResponse.state);
        }
        yield {
          state: yieldedResponse.state,
          data: partial
        };
      } else if (isConvoAI) {
        if (parsedHasExpectedKey('type', yieldedResponse.data)) {
          if (yieldedResponse.data.type === 'TRACE') {
            const loadingStatus = parsedHasExpectedKey('message', yieldedResponse.data) && parsedHasExpectedKey('message_template', yieldedResponse.data.message) ? yieldedResponse.data.message.message_template : '';
            partial = {
              ...partial,
              type: 'markdown',
              content: partial.content,
              meta: {
                inputOutputDiffRatio: '',
                loadingStatus
              }
            };
          }
          if (yieldedResponse.data.type === 'ANSWER_PART') {
            partial = {
              ...partial,
              type: 'markdown',
              content: partial.content + yieldedResponse.data.message.content,
              meta: {
                inputOutputDiffRatio: '',
                loadingStatus: ''
              }
            };
          }
          if (yieldedResponse.data.type === 'FINAL_RESPONSE') {
            var _message$message2, _message$message2$mes;
            const {
              message
            } = yieldedResponse.data;
            if (parsedHasExpectedKey('message_metadata', message.message) && parsedHasExpectedKey('response_too_similar', message.message.message_metadata) && message.message.message_metadata.response_too_similar) {
              var _message$message, _message$message$mess;
              return yield {
                state: 'failed',
                statusCode: message.status_code,
                reason: 'response-too-similar',
                data: {
                  meta: {
                    inputOutputDiffRatio: ((_message$message = message.message) === null || _message$message === void 0 ? void 0 : (_message$message$mess = _message$message.message_metadata) === null || _message$message$mess === void 0 ? void 0 : _message$message$mess.diff_ratio) || ''
                  }
                }
              };
            }
            partial = {
              ...partial,
              type: 'markdown',
              content: message.message.content,
              meta: {
                inputOutputDiffRatio: ((_message$message2 = message.message) === null || _message$message2 === void 0 ? void 0 : (_message$message2$mes = _message$message2.message_metadata) === null || _message$message2$mes === void 0 ? void 0 : _message$message2$mes.diff_ratio) || '',
                loadingStatus: ''
              }
            };
          }
          if (yieldedResponse.data.type === 'ERROR') {
            let statusCode;
            let guard;
            let error;
            let retryAfter;
            if (parsedHasExpectedKey('message', yieldedResponse.data)) {
              // Get status code
              if (parsedHasExpectedKey('status_code', yieldedResponse.data.message) && typeof yieldedResponse.data.message.status_code === 'number') {
                statusCode = yieldedResponse.data.message.status_code;
              }

              // Get reason
              if (parsedHasExpectedKey('message_template', yieldedResponse.data.message)) {
                guard = yieldedResponse.data.message.message_template;
              }

              // Get error
              if (parsedHasExpectedKey('content', yieldedResponse.data.message)) {
                error = yieldedResponse.data.message.content;
              }

              // Get retryAfter
              if (parsedHasExpectedKey('headers', yieldedResponse.data) && parsedHasExpectedKey('Retry-After', yieldedResponse.data.headers)) {
                retryAfter = Number(yieldedResponse.data.headers['Retry-After']);
              }
            }
            if (guard) {
              if (statusCode === 429) {
                return yield {
                  state: 'failed',
                  apiName: 'assistance-service',
                  statusCode,
                  guard,
                  error,
                  retryAfter
                };
              }
              return yield {
                state: 'failed',
                apiName: 'assistance-service',
                statusCode,
                guard,
                error
              };
            }
            return yield {
              state: 'failed',
              apiName: 'assistance-service',
              statusCode,
              guard: 'UNHANDLED_ERROR',
              error
            };
          }
          yield {
            state: yieldedResponse.state,
            data: partial
          };
        } else {
          // If there are any unexpected loading responses,
          // We should return the current data
          yield {
            state: yieldedResponse.state,
            data: partial
          };
        }
      }
      // if not expected response from the API the we have an error
      else {
        return yield {
          state: 'failed',
          reason: 'parsing'
        };
      }
    } else {
      if (yieldedResponse.state === 'failed' && yieldedResponse.reason !== 'response-too-similar' || yieldedResponse.state === 'aup-violation') {
        return yield yieldedResponse;
      } else {
        let responseTooSimilarData = {
          meta: parsedHasExpectedKey('meta', yieldedResponse.data) && parsedHasExpectedKey('inputOutputDiffRatio', yieldedResponse.data.meta) ? {
            inputOutputDiffRatio: yieldedResponse.data['meta']['inputOutputDiffRatio']
          } : partialMeta
        };
        return yield {
          state: 'failed',
          statusCode: 208,
          reason: 'response-too-similar',
          data: responseTooSimilarData
        };
      }
    }
  }
}